import styled from 'styled-components';

export const PageSubtitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 40px;
  }
`;

export const SortingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 24px;
    margin-bottom: 24px;
  }
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(3, 1fr) 30px;
  gap: 22px;
  padding: 0 24px;
  margin-bottom: 24px;
  align-items: center;

  h4 {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const CourseCard = styled(Legend)`
  flex-direction: row;
  padding: 38px 24px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
`;

export const CourseCardMobile = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px 8px;
  padding: 16px 0 28px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  align-items: center;

  > *:nth-child(even) {
    justify-self: flex-end;
    text-align: right;
  }

  .b3,
  .b4 {
    color: #515151;
  }

  h5 {
    color: #646464;
    text-transform: uppercase;
  }
`;
